import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
import { env } from 'endpoints';

import app from './app-dux/app-dux.js';
import companyData from './app-dux/company-dux.js';
import projects from './app-dux/projects-dux.js';
import editKey from './app-dux/edit-key-dux.js';
import exportContent from './app-dux/export-content-dux.js';
import importContent from './app-dux/import-content-dux.js';

const AppStore = () => {
	/*******************************************************************************
	 *	Gather all the reducers
	 */
	const appReducer = combineReducers( {
		app,
		companyData,
		projects,
		editKey,
		exportContent,
		importContent
	} );

	const rootReducer = ( state, action ) => {
		return appReducer( state, action );
	};

	/*******************************************************************************
	 *	Create Store
	 */
	const middleware = [ thunk ];

	if ( env ) {
		middleware.push( createLogger( {
			collapsed: true
		} ) );
	}

	return createStore(
		rootReducer,
		applyMiddleware( ...middleware )
	);
};

export default AppStore();
